/**
 * Removes thousands separators from a formatted number string
 * and returns a string suitable for database storage.
 *
 * @param {string} formattedNumber - The formatted number string (e.g., '1,234,567.89').
 * @returns {string} - The number string without commas (e.g., '1234567.89').
 */
export function FormatNumberTODecimal(formattedNumber) {
    if (!formattedNumber) {
        return parseFloat(0);
    }

    const cleanedNumber = formattedNumber.toString().replace(/,/g, '');

    return parseFloat(cleanedNumber);
}
